import { createContext } from 'react'
import { CalcMember } from '../doc/CalcMember'

interface CalcMemberViewContextValue {
  member: CalcMember
}

export const CalcMemberViewContext = createContext({} as CalcMemberViewContextValue)
